import { render, staticRenderFns } from "./schoolStudentsImport.vue?vue&type=template&id=153c8462&scoped=true&"
import script from "./schoolStudentsImport.vue?vue&type=script&lang=js&"
export * from "./schoolStudentsImport.vue?vue&type=script&lang=js&"
import style0 from "./schoolStudentsImport.vue?vue&type=style&index=0&id=153c8462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153c8462",
  null
  
)

export default component.exports